import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TravelServices.css";
import Modal from "../../../Pages/ModalForm";
import Heading from "../../../utls/Heading";

const TravelServices = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  return (
    <>
      <div className="container TravelServices">
        <div className="row">
          <div className="col-md-12">
            <Heading className="customheadings text-center">
              <span>Our Business</span> Travel Offerings
            </Heading>
          </div>

          <div className="row ps-3 ps-md-0">
            <div className="col-md-8  mt-4 paddingL">
              <h3 className="first-section headings common-before">
                Strategic Account Management
              </h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="fs5">
                  Looking for a strategic account manager to upgrade your
                  business travel? Our dedicated experts supervise every aspect
                  of your travel management, from daily team operations to
                  flawless travel experiences.
                </p>
              </div>
              <a href="/strategic" className="text-decoration-none">
                <div className="exploreBtn d-flex gap-md-3 gap-2">
                  <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">
                    EXPLORE MORE
                  </button>
                  <button className="arrow-btn border-0 bg-transparent">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png"
                      alt="right-arrow"
                      className="mt-1"
                      loading="lazy"
                    />
                  </button>
                </div>
              </a>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travelService1.png"
                  alt=""
                  className=" mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3 ps-md-0">
            <div className="col-md-8  mt-5 paddingL">
              <h3 className="second-section headings common-before">
                Corporate Travelers
              </h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="fs5">
                  Looking for hassle-free business travel? Utilize Blueberry
                  Travels’ personalized corporate travel solutions, VIP
                  services, tailored itineraries, and more for a smooth and
                  well-coordinated journey.
                </p>
              </div>
              <a href="/corporate" className="text-decoration-none">
                <div className="exploreBtn d-flex gap-md-3 gap-2">
                  <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">
                    EXPLORE MORE
                  </button>
                  <button className="arrow-btn border-0 bg-transparent">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png"
                      alt="right-arrow"
                      className="mt-1"
                      loading="lazy"
                    />
                  </button>
                </div>
              </a>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travelService2.png"
                  alt=""
                  className=" mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3 ps-md-0">
            <div className="col-md-8  mt-5 paddingL">
              <h3 className="third-section headings common-before">
                Entertainment Travel
              </h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="fs5">
                  Want to travel for entertainment? Blueberry Travel handles
                  everything from crew logistics to unforgettable vacation
                  experiences, ensuring your entertainment journey is flawless.
                </p>
              </div>
              <a href="/entertainment" className="text-decoration-none">
                <div className="exploreBtn d-flex gap-md-3 gap-2">
                  <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">
                    EXPLORE MORE
                  </button>
                  <button className="arrow-btn border-0 bg-transparent">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png"
                      alt="right-arrow"
                      className="mt-1"
                      loading="lazy"
                    />
                  </button>
                </div>
              </a>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travelService3.png"
                  alt=""
                  className=" mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3 ps-md-0">
            <div className="col-md-8  mt-5 paddingL">
              <h3 className="fourth-section headings common-before">
                Sports Travel
              </h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className=" fs5">
                  Want to experience sports like never before? Trust BBT then!
                  We transform every traveler's journey into a game-winning
                  experience with exclusive access, smooth logistics, and
                  memorable moments at top sporting events!
                </p>
              </div>
              <a href="/sports-travel" className="text-decoration-none">
                <div className="exploreBtn d-flex gap-md-3 gap-2">
                  <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">
                    EXPLORE MORE
                  </button>
                  <button className="arrow-btn border-0 bg-transparent">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png"
                      alt="right-arrow"
                      className="mt-1"
                      loading="lazy"
                    />
                  </button>
                </div>
              </a>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travelService4.png"
                  alt=""
                  className="  mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3 ps-md-0">
            <div className="col-md-8  mt-5 paddingL">
              <h3 className="fifth-section headings common-before">
                University Travel
              </h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className=" fs5">
                  Ready for the greatest college adventure? Whether you’re an
                  athlete, a study abroad aspirant, or committed to expanding
                  your healthcare knowledge, we offer customized, cost-effective
                  journeys for students. Your perfect getaway starts here!
                </p>
              </div>
              <a href="/university" className="text-decoration-none">
                <div className="exploreBtn d-flex gap-md-3 gap-2">
                  <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">
                    EXPLORE MORE
                  </button>
                  <button className="arrow-btn border-0 bg-transparent">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png"
                      alt="right-arrow"
                      className="mt-1"
                      loading="lazy"
                    />
                  </button>
                </div>
              </a>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travelService5.png"
                  alt=""
                  className="  mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row ps-3 ps-md-0">
            <div className="col-md-8  mt-5 paddingL">
              <h3 className="sixth-section headings common-before">
                Government Travel
              </h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="fs5">
                  Effortless, efficient, and secure travel solutions for
                  government professionals with Blueberry Travel—where
                  customized services and expert care are our commitments to
                  achieving your mission in a different place.
                </p>
              </div>
              <a href="/government" className="text-decoration-none">
                <div className="exploreBtn d-flex gap-md-3 gap-2">
                  <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">
                    EXPLORE MORE
                  </button>
                  <button className="arrow-btn border-0 bg-transparent">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png"
                      alt="right-arrow"
                      className="mt-1"
                      loading="lazy"
                    />
                  </button>
                </div>
              </a>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travelService6.png"
                  alt=""
                  className="  mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ....................time to upgrade section............................. */}

      <section className=" upgrade-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center text-md-start">
              <Heading className="headings text-white mt-2">
                <span>Ready to Level Up </span>Your Corporate Travel?
              </Heading>
              <div className="carouselCaption mt-md-3 mt-xxl-4 upgrade-btn">
                <button
                  className="btn fs4 fw-bold bg-transparent text-white text-uppercase leeter"
                  type="submit"
                  onClick={handleShow}
                >
                  LET’S BEGIN
                </button>
              </div>
              <Modal show={showModal} handleClose={handleClose} />
            </div>
            <div className="col-md-6">
              <div className="upgrade-img d-flex justify-content-center align-items-center">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/upgradeimage.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TravelServices;
